var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('p',{staticClass:"text-general f-14 px-3 pt-1 fr-light"},[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"icon-close text-general f-20 cr-pointer",on:{"click":function($event){return _vm.$emit('remove')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }